import * as angular from "angular";
import {IController} from "angular";

export class fulfillmentStatusesMultipleSelectCtrl implements IController {

  statuses: any;
  noUnderline: boolean;
  options: any;
  ngPlaceholder: string;
  onChange: Function;

  /* @ngInject */
  constructor(private FulfillmentConstants, private $mdSelect) {}

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.FulfillmentConstants.fulfillmentStatuses;
    }
  }

  onReset() {
    this.onChange({statuses: []});
    this.$mdSelect.hide();
  }

  onCancel() {
    this.$mdSelect.hide();
  }

  onSelect() {
    this.onChange({statuses: this.statuses});
    this.$mdSelect.hide();
  }

}
angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStatusesMultipleSelect', {
    bindings: {
      statuses: '<',
      noUnderline: '<?',
      options: '<?',
      ngPlaceholder: '<?',
      onChange: '&'
    },
    template: require('./fulfillment-statuses-multiple-select.html').default,
    controller: fulfillmentStatusesMultipleSelectCtrl
  });
